import ReactDOM from 'react-dom';
import App from './App';
import 'antd/dist/antd.less';
import './styles/global.less';
import { Provider } from 'react-redux';
import { store } from './models/store';

function render(props) {
  const { container } = props;
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    container ? container.querySelector('#root') : document.querySelector('#root')
  );
}

if (!window.__POWERED_BY_QIANKUN__) {
  render({});
}
